module.exports = __webpack_public_path__ + "media/merfoto/components/order-deliveries/delivery-methods/pick-up/logo-4682ef7184f87b9fb33f726f50e52eb5.png";